import React from 'react';
import {
  FORM_BORDER,
  FORM_BORDER_HOVER,
  FORM_BORDER_ERROR,
  FOCUS_RING,
  FOCUS_RING_ERROR,
  FORM_RADIUS,
  LABEL_TEXT,
  ERROR_TEXT,
} from './tokens';

interface TextInputProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly label?: string;
  readonly labelHelp?: React.ReactNode;
  readonly error?: string;
  readonly prefixIcon?: React.ReactNode;
  readonly disabled?: boolean;
  readonly required?: boolean;
  readonly id?: string;
  readonly placeholder?: string;
  readonly type?: string;
  readonly autoComplete?: string;
  readonly name?: string;
  readonly min?: string | number;
  readonly max?: string | number;
  readonly step?: string | number;
  readonly maxLength?: number;
  readonly onPaste?: React.ClipboardEventHandler<HTMLInputElement>;
  readonly onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  label,
  labelHelp,
  error,
  prefixIcon,
  disabled = false,
  required = false,
  id,
  placeholder,
  type = 'text',
  autoComplete,
  name,
  min,
  max,
  step,
  maxLength,
  onPaste,
  onBlur,
}) => {
  const borderClass = error ? FORM_BORDER_ERROR : `${FORM_BORDER} ${FORM_BORDER_HOVER}`;
  const focusClass = error ? FOCUS_RING_ERROR : FOCUS_RING;
  const disabledClass = disabled ? 'bg-slate-50 cursor-not-allowed' : 'bg-white';
  const paddingLeft = prefixIcon ? 'pl-12' : 'px-4';

  return (
    <div>
      {label && (
        <div className="flex items-center gap-1.5 mb-1.5">
          <label htmlFor={id} className={`block ${LABEL_TEXT}`}>
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
          {labelHelp}
        </div>
      )}
      <div className="relative">
        {prefixIcon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
            {prefixIcon}
          </div>
        )}
        <input
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          min={min}
          max={max}
          step={step}
          maxLength={maxLength}
          onPaste={onPaste}
          onBlur={onBlur}
          className={`w-full ${paddingLeft} pr-4 py-3 ${borderClass} ${focusClass} ${FORM_RADIUS} ${disabledClass}`}
        />
      </div>
      {error && <p className={ERROR_TEXT}>{error}</p>}
    </div>
  );
};
